export const getCookie = (name) => {
    if (typeof document === 'undefined') {
        return null;
    }

    const cookiePair = document.cookie
        .split(';')
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.startsWith(`${name}=`));

    if (!cookiePair) {
        return null;
    }

    return decodeURIComponent(cookiePair.substring(name.length + 1));
};

export const hasCookie = (name) => Boolean(getCookie(name));

export const setCookie = (name, value, options = {}) => {
    if (typeof document === 'undefined') {
        return;
    }

    const {
        path = '/',
        maxAge,
        sameSite = 'Lax',
        secure = false
    } = options;

    const cookieSegments = [`${name}=${encodeURIComponent(value)}`, `Path=${path}`, `SameSite=${sameSite}`];

    if (typeof maxAge === 'number') {
        cookieSegments.push(`Max-Age=${maxAge}`);
    }

    if (secure) {
        cookieSegments.push('Secure');
    }

    document.cookie = cookieSegments.join('; ');
};
